<template>
  <modal :show="!!open" @close="close" size="lg">
    <div>
      <div class="row align-items-center">
        <div class="col-md-3 col-6">
          <base-input label="วันที่">
            <flat-picker class="form-control datepicker" v-model="startDate" />
          </base-input>
        </div>
        <div class="col-md-3 col-6">
          <base-input label="ถึง">
            <flat-picker class="form-control datepicker" v-model="endDate" />
          </base-input>
        </div>
        <div class="col-md-3 col-12 search">
          <base-button
            type="default"
            @click="getTransactions()"
            :disabled="loading"
          >
            ค้นหา
          </base-button>
        </div>
      </div>

      <el-table
        class="mt-3"
        row-key="id"
        header-row-class-name="thead-light"
        :data="queriedData"
      >
        <el-table-column
          label="จาก"
          min-width="100px"
          v-if="type !== 'withdraw'"
        >
          <div slot-scope="{ row }">
            <span v-if="row.type === 'deduct'"> ตัดเครดิต </span>
            <span v-else-if="row.type === 'add'"> เติมเครดิต </span>
            <span v-else-if="row.type === 'promotion'"> รับโบนัส </span>
            <span v-else-if="row.type === 'wheel'"> กงล้อเสี่ยงโชค </span>
            <span v-else-if="row.type === 'cashback'"> รับแคชแบ็ก </span>
            <span v-else-if="row.type === 'affiliate_transfer'">
              โยกยอดแนะนำเพื่อน
            </span>
            <span v-else-if="row.type === 'new-reg-bonus'">
              แจกเครดิต <small>(สมาชิกใหม่)</small>
            </span>
            <span v-else-if="row.type === 'redeem'"> โค๊ดโปรโมชั่น </span>
            <span v-else>
              {{ row.transferFrom | bankName }}
            </span>
          </div>
        </el-table-column>
        <el-table-column label="ไปยัง" min-width="80px" v-else>
          <div slot-scope="{ row }">
            {{ row.transferTo | bankName }}
          </div>
        </el-table-column>
        <el-table-column label="จำนวน" min-width="100px">
          <div slot-scope="{ row }">
            <b>{{ row.amount | format(2) }}</b> บาท
            <small class="d-block text-muted" v-if="row.remark !== ''">
              {{ row.remark }}
            </small>
            <small class="d-block text-muted" v-if="row.turn && row.totalTurn">
              เทิร์น {{ row.turn }} เท่า - ยอดเทิร์น
              {{ row.totalTurn | format }}
            </small>
            <span class="d-block text-danger" v-if="row.operator !== ''">
              ทำรายการโดย <b>{{ row.operator }}</b>
            </span>
          </div>
        </el-table-column>
        <el-table-column label="สถานะ" align="center" min-width="80px">
          <div slot-scope="{ row }">
            <span class="badge badge-success" v-if="row.status === 'success'">
              ดำเนินการสำเร็จ
            </span>
            <span
              class="badge badge-warning"
              v-else-if="row.status === 'pending'"
            >
              รอดำเนินการ
            </span>
            <span
              class="badge badge-primary"
              v-else-if="row.status === 'checking'"
            >
              รอตรวจสอบ
            </span>
            <span class="badge badge-danger" v-else> รายการไม่สำเร็จ </span>
          </div>
        </el-table-column>
        <el-table-column label="เวลา" min-width="125px">
          <div slot-scope="{ row }">
            <span v-if="type === 'deposit'">
              {{ row.transferTime | moment("DD/MM/YYYY HH:mm:ss") }}
            </span>
            <span v-else>{{
              row.createdAt | moment("DD/MM/YYYY HH:mm:ss")
            }}</span>
            <small class="d-block text-muted">
              อัพเดทยอด:
              {{ row.updatedAt | moment("DD/MM/YYYY HH:mm:ss") }}
            </small>
          </div>
        </el-table-column>
        <el-table-column min-width="50px" v-if="type === 'withdraw'">
          <div slot-scope="{ row }">
            <base-button
              type="primary"
              size="sm"
              @click="viewQR(row.withdraw.qrString)"
              v-if="row.withdraw.qrString !== ''"
            >
              <i class="fas fa-qrcode" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
      <div class="card-footer d-flex justify-content-between">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </p>

        <base-pagination
          class="pagination-no-border"
          :per-page="pagination.perPage"
          :total="total"
          v-model="pagination.currentPage"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";

import moment from "moment";
import MemberService from "../../services/member.service";
import tablePagination from "../../mixins/tablePagination";
import QRCode from "davidshimjs-qrcodejs";
import Swal from "sweetalert2";

export default {
  props: ["open", "type"],
  mixins: [tablePagination([], 10)],
  components: {
    flatPicker,
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,

      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    viewQR(qrString) {
      Swal.fire({
        html: `<div class="d-flex justify-content-center">
					<div id="qr" class="ml--2"></div>
				</div>`,
      });

      const qr = new QRCode(document.getElementById("qr"), {
        width: 175,
        height: 175,
      });
      qr.clear();
      qr.makeCode(qrString);
    },
    getTransactions() {
      this.loading = true;
      MemberService.getTransactions(this.open, {
        start: this.startDate,
        end: this.endDate,
        type: this.type,
      })
        .then((res) => {
          this.updateTableData(res);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    open(v) {
      if (v) {
        this.updateTableData([]);
        this.getTransactions();
      }
    },
  },
};
</script>
